import BuchhaltungTemplate from './templates/BuchhaltungTemplate';
import { BUCHHALTUNG_CONFIG } from './config/buchhaltung';

export default function BuchhaltungDeutschland() {
  return <BuchhaltungTemplate cfg={BUCHHALTUNG_CONFIG.DE} />;
}
